export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  image: string;
  isHot?: boolean;
  isExclusive?: boolean;
}

export const articles: Article[] = [
  // 明星塌房
  {
    id: 'a001',
    title: '某顶流男星深夜被拍与神秘女子酒店共度三小时，疑似婚内出轨实锤曝光',
    summary: '据知情人爆料，某一线流量男星在妻子怀孕期间被拍到与年轻女子进出高档酒店，时间长达三小时。狗仔拍到男方衣衫不整匆忙离开，女方随后低调从后门溜走。',
    content: `<p>近日，娱乐圈再曝惊天大瓜。某流量男星李某（化名）在妻子怀孕期间被狗仔拍到与一名年轻神秘女子进出北京某五星级酒店，两人在酒店房间内停留长达三小时之久。</p>
<p>据现场狗仔透露，当晚十点左右，李某戴着黑色口罩和鸭舌帽低调进入酒店，半小时后一名身材高挑的年轻女子也进入同一房间。凌晨一点左右，李某衣衫不整地从酒店后门匆忙离开，神色慌张。约十五分钟后，该女子也从酒店侧门低调离去。</p>
<p>知情人士表示，李某与妻子结婚仅两年，妻子目前正处于怀孕晚期。此前两人一直以恩爱夫妻形象示人，频繁在社交媒体上互动秀恩爱。此次实锤照片一经流出，迅速登上微博热搜榜首，粉丝纷纷脱粉回踩。</p>
<p>更有网友扒出该女子疑似为某网红主播，曾在李某主演的电视剧首映礼上出现。两人在社交媒体上的互动也被翻出，蛛丝马迹颇多。李某工作室至今未对此事做出任何回应，疑似正在紧急公关中。</p>
<p>截至发稿，李某微博已经掉粉超过五十万，多个代言品牌已删除与其相关内容。业内预计此次塌房事件将导致其商业价值大幅缩水。</p>`,
    categorySlug: 'celebrity-scandals',
    categoryName: '明星塌房',
    author: '黑料君',
    publishDate: '2026-07-02',
    views: 2847563,
    tags: ['出轨', '顶流', '实锤', '酒店'],
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20lobby%20at%20night%20with%20dramatic%20lighting%20and%20mysterious%20atmosphere%2C%20dark%20cinematic%20style%2C%20warm%20amber%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-a001&orientation=landscape',
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'a002',
    title: '知名女演员被曝税务问题，补税金额高达八千万元，多个剧组紧急换角',
    summary: '税务总局近期通报多起艺人涉税案件，某S姓一线女演员赫然在列。据悉其通过阴阳合同、虚假申报等方式偷逃税款，被要求补缴税款及滞纳金共计超过八千万元。',
    content: `<p>国家税务总局近日发布的通报中，某S姓一线女演员被列为重点稽查对象。经查，该演员在2022年至2024年期间，通过签订阴阳合同、设立空壳公司、虚假业务申报等手段，偷逃个人所得税超过三千万元。</p>
<p>据剧组工作人员透露，该演员目前手上有四部待播作品和两部正在拍摄中的剧集。其中一部古装大制作已经拍摄过半，制作方正在紧急寻找替代演员，预计损失将超过两千万元。</p>
<p>该演员此前一直以"独立女性""税务合规"等人设活跃于公众视野，此次翻车让粉丝大跌眼镜。其代言的奢侈品牌、护肤品、汽车等十余个品牌已陆续宣布解约。</p>
<p>值得注意的是，这已是该演员第二次涉及税务问题。2019年其曾因同样的原因被警告，但显然并未吸取教训。业内人士表示，这次事件后该演员恐将面临行业封杀。</p>`,
    categorySlug: 'celebrity-scandals',
    categoryName: '明星塌房',
    author: '爆料小能手',
    publishDate: '2026-06-30',
    views: 1923456,
    tags: ['税务', '阴阳合同', '封杀', '补税'],
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20documents%20and%20tax%20forms%20scattered%20dramatically%20on%20dark%20desk%20with%20moody%20lighting%2C%20cinematic%20red%20and%20gold%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-a002&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a003',
    title: '选秀偶像团体C位成员被曝校园霸凌过往，同学集体发声指控',
    summary: '刚出道三个月的某男团C位成员张某被多名高中同学联合爆料，称其高中时期曾多次霸凌同学，包括勒索钱财、殴打同学、传播谣言等行为。',
    content: `<p>某选秀节目冠军、刚成团三个月的偶像团体C位成员张某，近日被多名高中同学联名爆料。十余名自称其高中同学的网友在社交媒体上发布长文，详细描述了张某在校期间的多项霸凌行为。</p>
<p>据爆料者称，张某在高中时期是当地有名的"校霸"，经常带领一帮小弟向低年级的学生收取"保护费"。更恶劣的是，他曾将一名同学逼至转学，原因是该同学考试成绩超过了他。</p>
<p>爆料还附有当年的班级群聊截图、被打同学的医疗记录，以及张某本人曾在社交媒体上发表的疑似威胁言论。其中一张2019年的照片显示，张某站在被打的男同学面前做出挑衅手势。</p>
<p>该偶像团体出道专辑刚刚发行一周，销量突破百万张。此事曝光后，粉丝在超话内吵翻，一部分认为"年少轻狂可以理解"，另一部分则坚决要求退团。已有两个音乐节宣布取消其演出。</p>`,
    categorySlug: 'celebrity-scandals',
    categoryName: '明星塌房',
    author: '校园线人',
    publishDate: '2026-06-28',
    views: 1567823,
    tags: ['校园霸凌', '偶像', '选秀', '退团'],
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20high%20school%20hallway%20with%20dramatic%20shadows%20and%20tense%20atmosphere%2C%20cinematic%20red%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-a003&orientation=landscape',
    isHot: false,
  },
  {
    id: 'a004',
    title: '某一线导演被指控性骚扰多位女演员，录音证据流出引发行业地震',
    summary: '圈内知名导演王某被多名女演员联合指控性骚扰，涉及长达十年的不当行为。最新流出的录音中，该导演以角色要挟女演员陪睡，内容不堪入耳。',
    content: `<p>曾执导多部票房过亿电影的知名导演王某，近日被五名女演员联合实名举报性骚扰。举报者称其在2015年至2024年期间，利用导演身份对多位女演员实施性骚扰，包括以角色分配为由要挟陪睡、在剧组对女演员动手动脚等。</p>
<p>最新流出的一段录音显示，王某在与一名试镜女演员的单独会面中，直言"想演女一号就得付出相应代价"，并做出露骨暗示。录音中女演员的抗拒和导演的威逼利诱形成鲜明对比，内容不堪入耳。</p>
<p>该导演目前担任两部大制作电影的总导演，其中一部已进入后期制作阶段。片方紧急召开会议商讨是否换人重拍或AI换脸。业内预计两部作品损失合计将超过三亿元。</p>
<p>中国导演协会今日发表声明，表示将严肃处理此类事件，维护行业风气。多家影视公司已宣布与该导演解除一切合作关系。</p>`,
    categorySlug: 'celebrity-scandals',
    categoryName: '明星塌房',
    author: '圈内人',
    publishDate: '2026-06-25',
    views: 3456210,
    tags: ['性骚扰', '导演', '录音', '举报'],
    image: 'https://readdy.ai/api/search-image?query=Film%20directors%20chair%20in%20dark%20empty%20studio%20with%20dramatic%20spotlight%2C%20moody%20cinematic%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20tones&width=800&height=500&seq=article-a004&orientation=landscape',
    isHot: true,
    isExclusive: true,
  },
  // 每日黑料
  {
    id: 'a005',
    title: '某小花被曝整容失败，近照脸部僵硬表情失控，网友惊呼认不出',
    summary: '95后当红小花赵某近日出席活动被拍到面部严重僵硬，表情不自然，疑似整容失败后遗症发作。对比旧照，面部轮廓已发生明显变化。',
    content: `<p>95后流量小花赵某昨日出席某品牌活动，现场生图流出后引发全网热议。照片中的赵某面部明显僵硬，笑容时嘴角歪斜，做表情时额头纹丝不动，被网友戏称为"AI假人"。</p>
<p>粉丝为偶像辩护称"只是没休息好""现场打光问题"，但医美博主纷纷出来分析，指出其面部多个部位存在明显的医美痕迹：额头玻尿酸填充过度、苹果肌下垂、嘴角两侧明显不对称。</p>
<p>更有网友翻出赵某2023年的照片进行对比，发现其面部轮廓发生了翻天覆地的变化。当时正值赵某主演的古装剧热播，她的"妈生脸"还曾被不少网友称赞。短短三年时间，颜值下滑如此严重，令人唏嘘。</p>
<p>赵某目前手握三个S级古偶项目，多个品牌代言。此次容貌争议恐将影响其后续资源。业内透露已有品牌在评估是否继续合作。</p>`,
    categorySlug: 'daily-gossip',
    categoryName: '每日黑料',
    author: '颜值观察员',
    publishDate: '2026-07-02',
    views: 987654,
    tags: ['整容', '小花', '颜值', '医美'],
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20fashion%20event%20spotlight%20with%20elegant%20red%20carpet%20atmosphere%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20editorial%20photography%20style&width=800&height=500&seq=article-a005&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a006',
    title: '某男星离婚真相曝光：竟是因赌博输掉千万家产，妻子忍无可忍',
    summary: '上月官宣离婚的某男星真实原因曝光，并非官方声明的"性格不合"，而是男方长期沉迷赌博，输掉近两千万元家产，妻子多次劝阻无果后选择离婚。',
    content: `<p>上个月以"性格不合"为由官宣离婚的某男星，真实离婚原因近日被曝光。据男方前妻的闺蜜透露，两人离婚的真实原因是男方长期沉迷境外网络赌博，短短两年时间输掉了近两千万元的积蓄。</p>
<p>该男星此前一直以"居家好男人""宠妻狂魔"人设示人，经常在综艺节目中讲述与妻子恩爱的日常，粉丝还给他起了"国民老公"的称号。谁能想到私下里竟是个赌鬼。</p>
<p>据悉，其妻子曾多次发现男方偷偷转账给境外赌博平台，两人为此多次大吵。去年男方甚至偷偷抵押了两人婚后购买的价值千万的婚房，妻子直到收到银行通知才知道真相。</p>
<p>目前该男星正在参加某竞技类综艺，节目组已收到通知准备剪辑其镜头。多个综艺节目和品牌正在评估合作风险。</p>`,
    categorySlug: 'daily-gossip',
    categoryName: '每日黑料',
    author: '离婚线人',
    publishDate: '2026-07-01',
    views: 1234567,
    tags: ['离婚', '赌博', '家暴', '财产'],
    image: 'https://readdy.ai/api/search-image?query=Broken%20family%20home%20interior%20with%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20warm%20amber%20and%20deep%20shadows%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a006&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a007',
    title: '某流量小生片场耍大牌，让全剧组等四小时，理由是"没睡好"',
    summary: '某95后流量小生拍摄古装大剧时多次迟到，最夸张一次让全剧组等了近四个小时。面对导演质问，经纪人给出的理由竟是"艺人昨晚没睡好，需要补觉"。',
    content: `<p>某S+级古装大剧剧组工作人员近日爆料，该剧男主角——一位95后顶流小生，自开机以来多次迟到早退，严重影响拍摄进度。最夸张的一次，全剧组从早上六点就位，等到上午十点才等来男主角，理由是"昨晚没睡好"。</p>
<p>据剧组场务透露，该小生平时在片场也经常玩手机不背台词，导致一场简单的对手戏要拍二十几遍。与其搭戏的老戏骨经常需要在片场枯等，敢怒不敢言。</p>
<p>更离谱的是，该小生还要求剧组为其单独配备五星级酒店套房，每天餐标高达两千元，连助理和化妆师都要配备独立房间。制片方虽然不满但忌惮其流量，只能忍气吞声。</p>
<p>目前该剧已拍摄过半，制作成本严重超支。业内人士预测，该剧播出时恐将引发新一轮对该小生的口碑危机。</p>`,
    categorySlug: 'daily-gossip',
    categoryName: '每日黑料',
    author: '片场卧底',
    publishDate: '2026-06-29',
    views: 876543,
    tags: ['耍大牌', '迟到', '片场', '古装'],
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20film%20set%20with%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-a007&orientation=landscape',
    isHot: false,
  },
  {
    id: 'a008',
    title: '某歌手演唱会假唱实锤，对口型穿帮被歌迷录下全过程',
    summary: '某实力派歌手在昨晚的万人演唱会上被歌迷拍下假唱证据。画面中歌手话筒远离嘴巴，但音响中歌声依然清晰，更夸张的是有一次歌手忘了举话筒，歌声照样响起。',
    content: `<p>某自诩"从不假唱"的实力派歌手昨晚在演唱会现场翻车。前排歌迷用手机拍下的视频显示，该歌手在演唱热门单曲时，多次出现话筒远离嘴巴但歌声依旧的情况。最尴尬的一幕发生在第二首歌曲的高潮部分，歌手两只手都用来与观众互动，话筒垂在腰侧，但高音部分依然完美播出。</p>
<p>视频在网上疯传，粉丝分成了两派：一派坚称是"和声轨道"，另一派则愤怒表示"花钱来听你现场，你给我放录音？"更有资深歌迷翻出该歌手十年前的演唱会视频进行对比，发现昨晚的演唱与十年前的录音几乎一模一样。</p>
<p>该歌手团队至今未对假唱争议做出正式回应，仅在粉丝群中表示"音响问题导致人声偏小"。但业内音响师出来科普：人声偏小只会导致听不清，不会出现话筒离嘴仍有歌声的情况。</p>
<p> ticket平台已开始收到大量退票申请，涉及金额超过五百万元。文旅部门表示将介入调查是否存在演出欺诈行为。</p>`,
    categorySlug: 'daily-gossip',
    categoryName: '每日黑料',
    author: '演唱会观察员',
    publishDate: '2026-06-27',
    views: 1567890,
    tags: ['假唱', '演唱会', '翻车', '对口型'],
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlights%20and%20smoke%20effects%2C%20dark%20moody%20atmosphere%2C%20warm%20red%20and%20gold%20lighting%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a008&orientation=landscape',
    isHot: true,
  },
  // 独家猛料
  {
    id: 'a009',
    title: '独家 | 某平台CEO包养多名女主播，转账记录曝光涉及金额超两千万',
    summary: '51黑料网独家获取某知名直播平台CEO与多名女主播的转账记录。记录显示该CEO在过去三年内累计向十余名女主播转账超过两千万元，部分备注竟直接写着"陪侍费"。',
    content: `<p>【51黑料网独家】某知名直播平台创始人兼CEO刘某，近日被本刊独家获取其与多名女主播的大额转账记录。这些记录显示，在2023年至2026年期间，刘某向至少十二名女主播进行过大额转账，累计金额超过两千万元。</p>
<p>最令人咋舌的是，部分转账备注直接写着"陪侍费""过夜费"等露骨字样。其中一名收到最多转账的女主播（累计超过四百万元），目前仍是该平台的一线主播，粉丝超过千万。</p>
<p>本刊还获取了该CEO与其中一名女主播的聊天记录。聊天内容涉及安排酒店、约会时间、转账金额等细节，部分对话内容不堪入目。该女主播曾向闺蜜透露，"只要陪他，一个月至少能拿到五十万"。</p>
<p>该平台目前已完成D轮融资，估值超过五十亿元。投资者表示正在核实此事，若属实将考虑撤回投资。该CEO今日已被公司宣布"因个人原因暂时休假"，但公司内部人员透露，董事会正在紧急讨论罢免事宜。</p>`,
    categorySlug: 'exclusive-news',
    categoryName: '独家猛料',
    author: '独家调查员',
    publishDate: '2026-07-01',
    views: 4235678,
    tags: ['CEO', '包养', '转账', '女主播'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20dramatic%20neon%20lighting%20and%20luxury%20setup%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a009&orientation=landscape',
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'a010',
    title: '独家 | 某一线男星工作室实为洗钱通道，警方已介入调查',
    summary: '51黑料网独家调查揭露，某一线男星旗下的工作室涉嫌参与洗钱活动。该工作室在过去两年内频繁与多家空壳公司发生大额资金往来，目前警方已立案调查。',
    content: `<p>【51黑料网独家调查】本刊经过长达六个月的跟踪调查，发现某一线男星陈某名下的个人工作室存在重大洗钱嫌疑。该工作室成立于2023年，注册资本仅十万元，但两年内累计流水超过两亿元。</p>
<p>调查发现，该工作室与多家注册在偏远地区的空壳公司存在频繁的大额资金往来。这些公司大多没有实际经营业务，却在收到工作室转账后迅速将资金转往境外账户。经核实，部分境外账户与某境外赌博集团有关联。</p>
<p>本刊掌握的银行流水显示，仅在2025年一年，该工作室就向六家空壳公司转账超过八千万元，这些公司均在收到款项后一周内注销。其中一家公司的注册地址经查证竟是一处废弃的养鸡场。</p>
<p>目前，警方经侦部门已正式立案调查。陈某团队昨日发布声明称"积极配合调查"，但拒绝回应任何具体问题。业内律师表示，若洗钱罪名成立，陈某最高可能面临十年以上有期徒刑。</p>`,
    categorySlug: 'exclusive-news',
    categoryName: '独家猛料',
    author: '财经调查组',
    publishDate: '2026-06-30',
    views: 3124567,
    tags: ['洗钱', '工作室', '警方', '调查'],
    image: 'https://readdy.ai/api/search-image?query=Financial%20investigation%20scene%20with%20scattered%20documents%20and%20bank%20statements%20on%20dark%20desk%2C%20moody%20dramatic%20lighting%2C%20warm%20amber%20and%20gold%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a010&orientation=landscape',
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'a011',
    title: '独家 | 某选秀节目决赛结果被操控，投票数据被曝造假内幕',
    summary: '51黑料网获取某热门选秀节目决赛后台数据，发现投票结果存在严重造假。冠军实际票数仅为公布数据的30%，真正的第一名被内定淘汰。',
    content: `<p>【51黑料网独家】本刊通过内部渠道获取了某热门选秀节目第三季决赛的原始投票数据。对比节目当晚公布的最终结果，存在严重的数据造假行为。</p>
<p>原始数据显示，选手A的实际得票数为128万票，但节目公布的数字为412万票，虚增超过三倍。而真正的第一名选手B实际得票数为356万票，却在节目中被公布为第三名。这种赤裸裸的操控让人瞠目结舌。</p>
<p>本刊还获取了一份疑似节目制片人与平台方的聊天记录。记录中明确提到"冠军必须给签约艺人""第三名的粉丝基础太弱，不好割韭菜"等露骨表述。</p>
<p>该选秀节目由某视频平台独家播出，前两季曾被誉为"最公平的选秀"。此次造假事件曝光后，前两季的投票数据也被网友质疑。目前节目官方微博已关闭评论。</p>`,
    categorySlug: 'exclusive-news',
    categoryName: '独家猛料',
    author: '数据分析师',
    publishDate: '2026-06-26',
    views: 2345678,
    tags: ['选秀', '造假', '投票', '内幕'],
    image: 'https://readdy.ai/api/search-image?query=Stage%20with%20dramatic%20spotlights%20and%20voting%20numbers%20floating%20in%20air%2C%20dark%20cinematic%20atmosphere%2C%20warm%20red%20and%20gold%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-a011&orientation=landscape',
    isHot: false,
    isExclusive: true,
  },
  // 影视圈
  {
    id: 'a012',
    title: '某S+古装剧片酬曝光：男女主各拿八千万，配角仅两万',
    summary: '某投资三亿元的古装大剧片酬清单流出，男女主角各自拿走八千万元片酬，占总投资的53%。而戏份不少的男二号和女二号片酬仅有两万元一集。',
    content: `<p>一部号称投资三亿元的S+级古装大剧，其片酬清单近日被内部人员泄露。数据显示，男女主角各自拿走八千万元片酬，两人合计1.6亿元，占总投资的53%。</p>
<p>与此形成鲜明对比的是，剧中戏份颇重的男二号（共出场四十集）每集片酬仅五百元，全部算下来仅有两万元。女二号（出场三十五集）每集片酬更是只有三百元。如此悬殊的片酬差距引发了业内对"天价片酬"问题的再次讨论。</p>
<p>更令人震惊的是，男女主角的片酬还包含了大量附加条款，如"必须使用指定造型团队"（费用另计五百万元）、"必须使用专属休息室"（装修费用两百万元）等。这些费用最终也都由剧组承担。</p>
<p>该剧制片人在朋友圈发文诉苦："三亿投资，一亿六千万给了主角，剩下还要做特效、做服化道、付群演工资，根本不够。成片质量大家到时候看吧。"</p>`,
    categorySlug: 'film-tv',
    categoryName: '影视圈',
    author: '影视观察员',
    publishDate: '2026-07-02',
    views: 1876543,
    tags: ['片酬', '古装', 'S+', '天价'],
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20film%20set%20with%20dramatic%20cinematic%20lighting%2C%20grand%20architecture%2C%20warm%20amber%20and%20gold%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-a012&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a013',
    title: '某大制作电影被曝滥用替身，男主角全程只露脸不到十分钟',
    summary: '某投资五亿元的大制作动作电影被工作人员爆料，男主角在片中实际出镜时间不到十分钟，其余所有动作戏、文戏均由替身完成，后期AI换脸处理。',
    content: `<p>某号称"史上最烧钱国产动作大片"的电影幕后真相被曝光。据剧组武术指导和多位群演透露，该片男主角在长达两个半小时的电影中，实际真人出镜时间不足十分钟。</p>
<p>工作人员详细爆料：文戏部分由三位替身演员分段完成，后期通过AI换脸技术替换成男主角的面孔。动作戏则由六位专业武替完成，男主角仅在绿幕前拍摄了十几组面部表情素材。</p>
<p>该片宣传期间，男主角频繁出席发布会讲述"拍摄时的辛苦""动作戏亲力亲为"等故事，粉丝还在评论区心疼偶像"太拼了"。真相曝光后，粉丝纷纷自嘲"心疼了个寂寞"。</p>
<p>更让人无语的是，该片男主角的片酬高达六千万元。这意味着他每分钟出镜的收入约为六百万元。业内人士表示，这种现象正在整个行业蔓延，"以后干脆不用请演员了，直接AI生成算了"。</p>`,
    categorySlug: 'film-tv',
    categoryName: '影视圈',
    author: '剧组线人',
    publishDate: '2026-06-29',
    views: 2345678,
    tags: ['替身', '电影', 'AI换脸', '片酬'],
    image: 'https://readdy.ai/api/search-image?query=Green%20screen%20film%20studio%20with%20dramatic%20lighting%20and%20camera%20equipment%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a013&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a014',
    title: '某知名编剧被曝抄袭，新剧本与网络小说相似度高达87%',
    summary: '某号称"原创鬼才"的知名编剧新作被文字比对软件检测出与某网络小说相似度高达87%。被抄袭的网络小说作者表示将起诉维权。',
    content: `<p>曾获得多个编剧奖项的知名编剧周某，其最新播出的悬疑剧剧本被扒出严重抄袭。网友使用文字比对软件对剧本和一本2021年连载的网络小说进行比对，结果显示相似度高达87%，核心情节、人物设定、关键台词几乎全部照搬。</p>
<p>被抄袭的网络小说作者"夜行者"在社交媒体上发布长文，详细列举了剧本与自己小说的雷同之处。其中包括一个"倒叙五重反转"的核心诡计，该诡计在小说评论区曾被读者反复讨论，剧本竟然连反转顺序都完全一致。</p>
<p>周某此前一直以"每部作品都是原创""从不用枪手"自居，还曾在采访中嘲讽其他编剧"抄袭的都是没才华的人"。此次翻车被网友称为"2026年娱乐圈最大回旋镖"。</p>
<p>"夜行者"已委托律师准备起诉，要求编剧周某和制作方赔偿五百万元并公开道歉。法律人士表示，相似度超过80%已构成实质性侵权，胜诉概率很高。</p>`,
    categorySlug: 'film-tv',
    categoryName: '影视圈',
    author: '文学侦探',
    publishDate: '2026-06-24',
    views: 1456789,
    tags: ['抄袭', '编剧', '维权', '网络小说'],
    image: 'https://readdy.ai/api/search-image?query=Dark%20writers%20desk%20with%20scattered%20manuscripts%20and%20laptop%20showing%20text%20comparison%2C%20moody%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-a014&orientation=landscape',
    isHot: false,
  },
  // 网红瓜
  {
    id: 'a015',
    title: '千万粉丝网红被曝学历造假，清华毕业实为大专辍学',
    summary: '以"清华才女"人设走红的千万粉丝网红林某某被同学爆料学历造假。其声称的清华硕士学历实为某大专院校辍学，清华校园照系花钱找人拍摄。',
    content: `<p>在短视频平台拥有超过一千五百万粉丝的网红林某某，一直以"清华硕士""学霸博主"的人设吸粉。她经常在视频中展示"清华校园生活""清华图书馆学习日常"等内容，吸引大量学生和家长关注。</p>
<p>然而，近日其大学同学在网络上爆料，林某某实际就读的是某大专院校的服装设计专业，且在大二时就因成绩太差被退学。所谓的"清华硕士"纯属虚构，而那些清华校园视频和照片，则是她花钱雇人陪同进入校园拍摄的。</p>
<p>更离谱的是，其视频中经常提到的"清华导师"，经查证根本不存在此人。那些"导师推荐信""获奖证书"等展示物，均为网上购买的假证件。</p>
<p>目前林某某已经删除所有提及清华的内容，账号设置为私密。但其代言的教育类产品、学习APP等已收到大量用户投诉，多个品牌已宣布终止合作。</p>`,
    categorySlug: 'influencer-drama',
    categoryName: '网红瓜',
    author: '学历侦探',
    publishDate: '2026-07-01',
    views: 1678902,
    tags: ['学历造假', '网红', '人设', '清华'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20university%20campus%20with%20dramatic%20architectural%20elements%20and%20moody%20lighting%2C%20warm%20amber%20and%20gold%20tones%2C%20cinematic%20editorial%20photography%20style&width=800&height=500&seq=article-a015&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a016',
    title: '头部带货主播直播间"福利"翻车，所谓抽奖实为雇水军内定',
    summary: '某头部带货主播直播间宣称的"粉丝福利抽奖"被工作人员爆料实为内定。中奖名单提前确定，所谓的中奖观众都是主播团队内部人员或雇佣的水军。',
    content: `<p>坐拥五千万粉丝的头部带货主播张某，其直播间每晚都会进行多轮"粉丝福利抽奖"，奖品从手机到现金不等。然而，一位离职的运营人员近日爆料，这些抽奖活动全部是内定的。</p>
<p>该运营人员提供了多份"中奖名单模板"，名单上的"幸运观众"账号经查证，要么是主播团队成员的小号，要么是专门雇佣的水军账号。更有意思的是，其中几个"中奖者"在半年内已经"中奖"超过二十次。</p>
<p>直播间里每当抽奖环节，弹幕都会刷起"恭喜中奖""太羡慕了"，营造出一种抽奖公平的氛围。而实际上，真正的粉丝中奖概率为零。主播团队甚至开发了专门的软件来筛选"永远不会中奖"的真实粉丝ID。</p>
<p>张某带货的产品此前已多次被曝光质量问题，如今又曝出抽奖造假，粉丝信任度进一步崩塌。昨日直播观看人数较上月同期下降了60%，带货转化率暴跌。</p>`,
    categorySlug: 'influencer-drama',
    categoryName: '网红瓜',
    author: '直播间卧底',
    publishDate: '2026-06-28',
    views: 1234567,
    tags: ['带货', '抽奖', '造假', '水军'],
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20colorful%20neon%20lights%20and%20product%20displays%2C%20dramatic%20dark%20atmosphere%2C%20warm%20red%20and%20gold%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a016&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a017',
    title: '某颜值网红被曝早年从事特殊行业，大量不雅照流出',
    summary: '以清纯形象走红的百万粉丝颜值网红被曝早年曾在多个特殊场所工作，大量不雅照片和视频流出。其"富家千金"人设也随之崩塌，被扒出家境实为农村。',
    content: `<p>在多个平台拥有总计超过五百万粉丝、以"清纯校花""富家千金"人设走红的网红陈某某，近日被爆料早年曾在多个夜总会和会所工作。爆料者提供了大量工作期间的内部照片和视频。</p>
<p>更讽刺的是，陈某某在走红后一直在视频中展示"豪宅""奢侈品""名媛日常"，营造出出身豪门的假象。但网友通过其早年社交媒体账号和老乡爆料，发现她实际上来自某农村家庭，父母都是普通农民。</p>
<p>所谓"豪宅"经查证是月租三千元的民宿，"奢侈品"多为高仿假货，"名媛下午茶"则是去高档酒店只点一杯最便宜的咖啡然后拍照两小时。</p>
<p>目前陈某某已经清空所有视频，账号设置为私密，但流出的不雅内容仍在网络上传播。其签约的MCN机构已单方面宣布解约，并要求赔偿违约金三百万元。</p>`,
    categorySlug: 'influencer-drama',
    categoryName: '网红瓜',
    author: '匿名爆料者',
    publishDate: '2026-06-25',
    views: 2876543,
    tags: ['网红', '人设崩塌', '不雅照', 'MCN'],
    image: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20flat%20lay%20with%20fake%20designer%20bags%20and%20jewelry%20on%20dark%20surface%2C%20dramatic%20lighting%20revealing%20cheap%20details%2C%20warm%20amber%20and%20red%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-a017&orientation=landscape',
    isHot: true,
  },
  // 综艺爆料
  {
    id: 'a018',
    title: '某真人秀节目剧本曝光，嘉宾冲突全是导演组安排',
    summary: '某热门真人秀节目的内部剧本流出，显示节目中所有"激烈冲突""感人瞬间""意外发现"都是按照剧本提前安排好的，连嘉宾的眼泪都是有"哭戏指标"。',
    content: `<p>号称"零剧本""全真实"的某热门真人秀节目，其内部拍摄剧本近日被工作人员泄露。剧本详细标注了每一期节目需要发生的"事件"和"冲突"，甚至连嘉宾的情绪反应都有明确要求。</p>
<p>剧本中明确写着："第三期需要在用餐环节制造冲突，A嘉宾负责挑刺，B嘉宾负责反击，C嘉宾负责劝架。冲突时间控制在8-10分钟，之后D嘉宾负责化解矛盾并升华主题。"</p>
<p>更有意思的是，所谓的"意外发现"和"惊喜环节"也都提前写好了。一期节目中嘉宾"偶然"发现的一封信，实际上是拍摄前一天导演组放进去的，那封信的内容也经过了三次修改才定稿。</p>
<p>最令观众受伤的是，那些"感人至深"的泪点场景也有明确的"哭戏指标"。剧本中标注"本期需要3个泪点，分别由A、C、E三位嘉宾负责。E嘉宾泪点不足，准备洋葱辅助。"</p>`,
    categorySlug: 'variety-show',
    categoryName: '综艺爆料',
    author: '剧本泄露者',
    publishDate: '2026-06-30',
    views: 1987654,
    tags: ['真人秀', '剧本', '造假', '泪点'],
    image: 'https://readdy.ai/api/search-image?query=Reality%20TV%20control%20room%20with%20multiple%20monitors%20showing%20contestants%2C%20dramatic%20dark%20atmosphere%2C%20warm%20red%20and%20amber%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a018&orientation=landscape',
    isHot: true,
  },
  {
    id: 'a019',
    title: '某音乐综艺评委被曝收受选手贿赂，晋级名单提前内定',
    summary: '某音乐选秀综艺的评委被多名淘汰选手联合举报收受现金贿赂。据称交五十万元可保晋级下一轮，一百万元可保送决赛。',
    content: `<p>某S级音乐选秀综艺正在热播，但节目背后的黑幕令人触目惊心。五名已被淘汰的选手联合向媒体爆料，称该节目的核心评委存在严重的收受贿赂行为。</p>
<p>据爆料者称，节目开播前就有"中介"主动联系有经济实力的选手，声称"交五十万保晋级下一轮，交一百万保送决赛"。多名选手为了确保晋级，不得不向"中介"支付高额费用。</p>
<p>一位家境殷实的选手透露，自己总共支付了八十万元，其中五十万元用于"保过"第二轮，另外三十万元用于"影响"其他评委的打分。但最终因另一位"出价更高"的选手竞争，自己还是在第三轮被淘汰。</p>
<p>更讽刺的是，该评委在节目中一直以"公正严谨""坚持音乐品质"的形象示人，还多次在节目中怒斥选手"你们不是来比赛的，是来卖惨的"。如今看来，不过是表演给镜头看的罢了。</p>`,
    categorySlug: 'variety-show',
    categoryName: '综艺爆料',
    author: '选手联盟',
    publishDate: '2026-06-22',
    views: 1456789,
    tags: ['评委', '贿赂', '晋级', '黑幕'],
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlights%20and%20judges%20panel%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20gold%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a019&orientation=landscape',
    isHot: false,
  },
  {
    id: 'a020',
    title: '某恋综嘉宾塌房，节目播出期间被曝已婚已育，参加节目只为炒作',
    summary: '某热门恋爱综艺的男嘉宾在节目中深情款款追求女嘉宾，却被网友扒出早已结婚并育有一子。其妻子在社交媒体上发文控诉，称丈夫参加节目前两人并未离婚。',
    content: `<p>正在热播的某恋爱综艺中，男嘉宾刘某对女嘉宾展开猛烈追求，两人在节目中的甜蜜互动让不少观众直呼"磕到了"。然而，就在最新一期播出当晚，有网友扒出刘某其实已经结婚，并且育有一个三岁的儿子。</p>
<p>刘某的妻子王某在社交媒体上发布长文，详细讲述了事情经过。她表示两人2019年结婚，2022年生下儿子。三个月前刘某告诉她"要出长差拍一个职场综艺"，她毫不知情这是一个恋爱节目。直到上周节目播出，朋友发链接给她，她才知道真相。</p>
<p>王某还晒出了两人的结婚证、儿子的出生证明，以及刘某出差前发的微信消息。消息中刘某写道"这次拍摄可能要保密，你千万别跟别人说我在参加节目"。</p>
<p>节目组今日发表声明，称"对嘉宾信息审核不严"并向观众道歉，同时宣布将删除刘某在该节目中的所有镜头。女嘉宾也通过工作室表示"完全不知情""也是受害者"。</p>`,
    categorySlug: 'variety-show',
    categoryName: '综艺爆料',
    author: '婚姻侦探',
    publishDate: '2026-06-20',
    views: 2345678,
    tags: ['恋综', '已婚', '塌房', '炒作'],
    image: 'https://readdy.ai/api/search-image?query=Romantic%20reality%20show%20set%20with%20candlelit%20dinner%20scene%20and%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-a020&orientation=landscape',
    isHot: true,
  },
];